export const container = `w-full`;
